<script setup>
const props = defineProps({
  id: Number,
  title: String,
});
</script>

<template>
  <div class="tile relative w-full h-full pt-100p md:pt-0">
    <div class="tile__inner absolute inset-[10px] group overflow-hidden">
      <Livestream :title="title" />
    </div>
  </div>
</template>

<style></style>
